import { render, staticRenderFns } from "./detailPartner.vue?vue&type=template&id=5d7e1201&"
import script from "./detailPartner.vue?vue&type=script&lang=js&"
export * from "./detailPartner.vue?vue&type=script&lang=js&"
import style0 from "./detailPartner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports